import { useQuery } from 'react-query';
import { productService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useFetchTaxonFilters = (slug: string) => {
  return useQuery(
    `${ServerStateKeysEnum.taxonFilters}-${slug}`,
    () => {
      // return productService.getTaxonFilters(slug);
    },
    {
      keepPreviousData: true,
    }
  );
};
